import { Box, Grid, Skeleton, Typography } from '@mui/material'

export const FeaturedTokenSkeleton = () => {
    return (
        <Grid container spacing={4} mt={4}>
            <Grid item md={4} xs={12}>
                <Typography component="div" style={{ width: '10%' }} variant="body1"><Skeleton /></Typography>
                <Typography component="div" style={{ width: '50%' }} variant="body1"><Skeleton /></Typography>
                <br />
                <Box >
                    <Grid container spacing={4} >
                        <Grid item md={6} xs={12}>
                            <Typography component="div" className="w-100" variant="body1"><Skeleton /></Typography>
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <Typography component="div" className="w-100" variant="body1"><Skeleton /></Typography>
                        </Grid>
                    </Grid>
                </Box>
                <br />
                <Typography component="div" style={{ width: '100%' }} variant="body1"><Skeleton /></Typography>
                <Typography component="div" style={{ width: '100%' }} variant="body1"><Skeleton /></Typography>
                <Typography component="div" style={{ width: '60%' }} variant="body1"><Skeleton /></Typography>
            </Grid>
            <Grid item md={8} xs={12}>
                <Skeleton animation="wave" variant="rectangular" width={'100%'} height={'100%'} />
            </Grid>
        </Grid>
    )
}
